import { render, staticRenderFns } from "./HoverList.vue?vue&type=template&id=52b09b7d&scoped=true"
import script from "./HoverList.vue?vue&type=script&lang=js"
export * from "./HoverList.vue?vue&type=script&lang=js"
import style0 from "./HoverList.vue?vue&type=style&index=0&id=52b09b7d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b09b7d",
  null
  
)

export default component.exports